import { render, staticRenderFns } from "./CertificateRegister.vue?vue&type=template&id=2d38385f&scoped=true&"
import script from "./CertificateRegister.vue?vue&type=script&lang=js&"
export * from "./CertificateRegister.vue?vue&type=script&lang=js&"
import style0 from "./CertificateRegister.vue?vue&type=style&index=0&id=2d38385f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38385f",
  null
  
)

export default component.exports